import React, { Component } from 'react';
import MainDrawer from '../InternalNavigation/drawer';
import { Row, Col } from 'react-bootstrap';
import Reservation from './Reservation'
import InternalNavigation from '../InternalNavigation';
import { selectors as session_selectors } from '../sagas/session';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import { actions } from '../sagas/session'

class NewReservation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drawer: false
    };
  }

  toggleDrawer = () => {
    this.setState({drawer: !this.state.drawer})
  }

  render () {
    return (
      <div>
        { checkRole('user', this.props.role) &&
          <div>
            <MainDrawer
              position={'left'}
              openState={this.state.drawer}
              toggleDrawer={this.toggleDrawer}
              className='drawer'/>
            <InternalNavigation
              toggleDrawer={this.toggleDrawer}/>
          </div>
          }
          <div>
            <span>
              <Row>
                <Col
                  xs={12}
                  className='reservation-wrapper'>
                    <Reservation />
                  </Col>
              </Row>
            </span>
          </div>
      </div>
    );
  }

};

const checkRole = (minRole, role) => {
  return roleCanView()[role].includes(minRole)
}

const roleCanView = () => ({
  'admin': ['admin', 'accountant', 'user'],
  'accountant': ['accountant', 'user'],
  'user': ['user'],
  'non_user': []
})

const mapStateToProps = (store) => ({
  token: session_selectors.token(store),
  role: session_selectors.role(store)
})

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch)

export default connect(mapStateToProps, mapDispatchToProps, null,
)(NewReservation);



// WEBPACK FOOTER //
// ./src/Reservations/new.jsx